<template>
<section>
    <div class="container">
        <section id="login" class=" border-black">
            <div class="columns">
                <div class="column is-half is-offset-one-quarter">
                    <center><img src="@/assets/img/logo_title.png" width="200"/></center>
                </div>
            </div>
            <div class="columns">
                <div class="column">&nbsp;</div>
                <div class="column is-10">
                    <form @submit="onSubmit" ref="form">
                        <loading :active.sync="isLoading"
                            :can-cancel="false"
                            :is-full-page="false">
                        </loading>
                        <h2 class="text-center">Admin Login</h2>
                        <b-field label=""
                            type="is-grey"
                            message="Please enter a valid email">
                            <b-input type="email" name="email" v-model="input.email" placeholder="E-mail"></b-input>
                        </b-field>
                        <b-field label=""
                            type="is-grey"
                            message="Please enter your password">
                            <b-input type="password" name="password" v-model="input.password" placeholder="Password"></b-input>
                        </b-field>
                        <b-field :message="errors"
                            type="is-danger"
                            name="errors"
                            >
                        </b-field>
                            <button type="submit" class="button is-studentqr  is-fullwidth" ref="submitButton" expanded>Login</button>
                            <!-- <b-button type="is-primary" ref="submitButton" expanded>Login</b-button> -->
                    </form>
                </div>
                <div class="column">&nbsp;</div>
            </div>
            <div class="columns">
                <div class="column">&nbsp;</div>
                <div class="column is-10 bottom-link">
                    <span v-on:click="goLoginAsTeacher()">or Login as Teacher/Supervisor</span>
                    <span v-on:click="goLoginProblem()" style="float: right; color: #ff0000">Problem login?</span>
                </div>
                <div class="column">&nbsp;</div>
            </div>
        </section>
    </div>
</section>
<!-- <div class="card">
    <loading :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true">
    </loading>
    <div class="card-content">
        <div class="columns">
            <section id="login">
                <h1>Admin Login</h1>
                <img src="@/assets/img/logo.png" />
                <form @submit="onSubmit" ref="form">
                    <loading :active.sync="isLoading"
                        :can-cancel="false"
                        :is-full-page="false">
                    </loading>
                    <b-field label=""
                        type="is-warning"
                        message="Please enter a valid email">
                        <b-input type="email" name="email" v-model="input.email" placeholder="E-mail"></b-input>
                    </b-field>
                    <b-field label=""
                        type="is-warning"
                        message="Please enter your password">
                        <b-input type="password" name="password" v-model="input.password" placeholder="Password"></b-input>
                    </b-field>
                    <b-field :message="errors"
                        type="is-danger"
                        name="errors"
                        >
                        <button type="submit" class="button" ref="submitButton">Login</button>
                    </b-field>
                </form>
            </section>
        </div>
    </div>
    <footer class="card-footer">
                <a href="#" class="card-footer-item" v-on:click="editData()">Edit</a>
                <a href="#" class="card-footer-item" v-on:click="deleteData(data)">Delete</a>
    </footer>
</div> -->

</template>

<script>

import axios from 'axios'
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    name: 'login',
    components: {
        Loading,
    },
    data () {
        return {
            isLoading: false,
            input: {
                email: "",
                password: ""
            },
            result : "",
            errors: []
        }
    },
    mounted() {
        var autoLoginAfterReload = localStorage.getItem('autoLoginAfterReload')

        if (autoLoginAfterReload == "1"){
            // this.onSubmit()
            this.input.email = localStorage.getItem('input_email')
            this.input.password = localStorage.getItem('input_pass')
            this.$refs.submitButton.click()
        }
    },
    methods: {
        onSubmit (evt) {
            evt.preventDefault()
            this.submitLogin()
        },
        submitLogin(){
            console.log("132 cuba login")
            let self = this
            if(this.input.email != "" && this.input.password != "") {
                this.isLoading = true;
                axios.defaults.responseType = 'json'
                // axios.post(process.env.MY_URL + '/api/auth/admin/login', this.input)
                axios.post(process.env.MY_URL + '/admin/login', this.input)
                .then(response => {
                    console.log("imini 79 response: ")
                    console.log(response.data)
                    localStorage.setItem('input_email','')
                    localStorage.setItem('input_pass','')
                    localStorage.setItem('autoLoginAfterReload','0')
                    console.log("imini response.data")
                    console.log(response.data)
                    if (response.data.success){
                        this.isLoading = false;
                        localStorage.setItem('user',JSON.stringify(response.data.user))
                        localStorage.setItem('jwtToken', response.data.token)
                        localStorage.setItem('jwtTokenV2', response.data.tokenV2)
                        localStorage.setItem('email',this.input.email)
                        localStorage.setItem('sessionID', response.data.user.sessionID)
                        localStorage.setItem('schoolID', response.data.schoolID)
                        localStorage.setItem('schoolName', response.data.schoolName)
                        localStorage.setItem('schoolLogo', response.data.schoolLogo)
                        localStorage.setItem('newToken', response.data.newToken)
                        localStorage.setItem('country', response.data.country)
                        localStorage.setItem('schoolNo', response.data.schoolNo)
                        localStorage.setItem('plan', response.data.plan)
                        localStorage.setItem('enableLiveLeaderboard', response.data.enableLiveLeaderboard)
                        localStorage.setItem('userType', response.data.userType)
                        sessionStorage.setItem('userLogin', this.input.password)
                        if (localStorage.getItem('jwtToken') != null){
                            this.$emit("authenticated", true)
                            this.$emit('loggedIn')
                            if(this.$route.params.nextUrl != null){
                                this.$router.push(this.$route.params.nextUrl)
                            }else {
                                this.$router.push('/Home')
                            }
                        }
                    }else{
                        this.isLoading = false;
                        console.log("salah login")
                        this.errors.push(response.data.msg)
                    }
                })
                .catch(e => {
                    console.log(e)
                    localStorage.clear();

                    //auto reload in 10 seconds if there's an error while logging in
                    setTimeout(function() {
                        localStorage.setItem('input_email',self.input.email)
                        localStorage.setItem('input_pass',self.input.password)
                        localStorage.setItem('autoLoginAfterReload','1')
                        location.reload();
                    }, 10000);

                    if(e.response.status === 401) {
                        console.log("salah login")
                        this.errors.push("Invalid login")
                    }else{
                        this.errors.push(e)
                    }
                    this.isLoading = false;
                })
            } else {
                this.result = "An email and password must be present"
                console.log("An email and password must be present")
            }
        },
        goLoginAsTeacher(){
            window.open("https://teacher.studentqr.com/", '_blank');
        },
        goLoginProblem(){
            window.open("https://helpstudentqr.wasap.my/", '_blank');
        },
    }
}
</script>

<style scoped>
    #login {
        background-color: #FFFFFF;
        padding-left: 30px;
        padding-right: 30px;
        padding-top: 60px;
        padding-bottom: 100px;
        margin: 0 auto;
        margin-top: 20px;
        border-radius: 20px;
        border-color: #ccc;
        width: 80%;
    }
    h2{
        font-weight: bold;
        margin-bottom: 10px;
        color: #000;
    }
    .bottom-link{
        color: #000;
        font-size: 13px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue